module.exports = __webpack_public_path__ + "img/sixpackcarrier98.d6cc0b4b.jpg";